export const maskCpfCnpj = (value) => {
  // Remove tudo o que não é dígito
  value = value.replace(/\D/g, '');

  if (value.length <= 11) {
    // CPF
    value = value.replace(/(\d{3})(\d)/, '$1.$2');
    value = value.replace(/(\d{3})(\d)/, '$1.$2');
    value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  } else if (value.length <= 14) {
    // CNPJ com 14 dígitos
    value = value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})/, '$1.$2.$3/$4');
    value = value.replace(/(\d{2})$/, '-$1');
  } else {
    // CNPJ com mais de 14 dígitos
    value = value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  }

  if (value.length > 18) return value.slice(0, 18);
  return value;
};
